module.exports = __webpack_public_path__ + "static/media/courses.054be040.xlsx";